import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

// Debug logging - remove this in production
console.log('Available env vars:', {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ? 'defined' : 'undefined',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN
    ? 'defined'
    : 'undefined',
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL
    ? 'defined'
    : 'undefined',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ? 'defined' : 'undefined',
});

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
